import { render } from "./IpRangesTabGuest.vue?vue&type=template&id=a57d4ed0&scoped=true"
import script from "./IpRangesTabGuest.vue?vue&type=script&lang=js"
export * from "./IpRangesTabGuest.vue?vue&type=script&lang=js"

import "./IpRangesTabGuest.vue?vue&type=style&index=0&id=a57d4ed0&lang=scss&scoped=true"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57d4ed0"]])

export default __exports__